exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.flash {\n  margin: 10px 0px 0px 0px;\n  top: 0px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/flash-message/styles.css
// module id = 1564
// module chunks = 29